(function attachCalculatorEngine(global) {
  var FORMAT_DIMENSIONS = {
    B4: { width: 26, height: 35 },
    A7: { width: 6, height: 10 },
    A6: { width: 10, height: 14 },
    A5: { width: 14, height: 21 },
    "A4+": { width: 21, height: 30 },
    A4: { width: 21, height: 28 },
    "A3+": { width: 30, height: 43 },
    A3: { width: 28, height: 42 },
    A2: { width: 42, height: 58 },
    "Mètre": { width: 100, height: 57 },
    Coeur: { width: 8.5, height: 8.5 },
    "Étiquette": { width: 5, height: 5 },
    Small: { width: 7, height: 7 }
  };

  function roundMoney(amount) {
    return Math.round((Number(amount) + Number.EPSILON) * 100) / 100;
  }

  function normalizeLogo(logo) {
    var w = Number(logo.width || 0);
    var h = Number(logo.height || 0);
    return {
      id: logo.id || logo.name,
      name: logo.name || logo.id || "Logo",
      color: logo.color || "#666",
      width: Math.min(w, h),
      height: Math.max(w, h),
      quantity: Math.max(0, Math.floor(Number(logo.quantity || 0)))
    };
  }

  function gridCapacity(format, w, h, spacing) {
    var cols = Math.floor((format.width + spacing) / (w + spacing));
    var rows = Math.floor((format.height + spacing) / (h + spacing));
    if (cols <= 0 || rows <= 0) return { count: 0, cols: 0, rows: 0 };
    return { count: cols * rows, cols: cols, rows: rows };
  }

  function buildSingleLogoBlueprint(logo, format, spacingCm, allowRotate) {
    var base = gridCapacity(format, logo.width, logo.height, spacingCm);
    var rotated = allowRotate && logo.width !== logo.height
      ? gridCapacity(format, logo.height, logo.width, spacingCm)
      : { count: 0, cols: 0, rows: 0 };

    var useRotated = rotated.count > base.count;
    var cellW = useRotated ? logo.height : logo.width;
    var cellH = useRotated ? logo.width : logo.height;
    var best = useRotated ? rotated : base;
    if (best.count <= 0) return null;

    var placements = [];
    for (var r = 0; r < best.rows; r++) {
      for (var c = 0; c < best.cols; c++) {
        placements.push({
          id: logo.id,
          name: logo.name,
          color: logo.color,
          x: c * (cellW + spacingCm),
          y: r * (cellH + spacingCm),
          width: cellW,
          height: cellH
        });
      }
    }

    var perSheet = {};
    perSheet[logo.id] = best.count;

    return {
      format: format,
      placements: placements,
      perSheet: perSheet,
      totalOnSheet: best.count
    };
  }

  function aggregateCoverage(logos, actions) {
    var produced = {};
    var demanded = {};
    var totalDemand = 0;
    var surplus = 0;

    for (var i = 0; i < logos.length; i++) {
      demanded[logos[i].id] = logos[i].quantity;
      produced[logos[i].id] = 0;
      totalDemand += logos[i].quantity;
    }
    for (var a = 0; a < actions.length; a++) {
      var action = actions[a];
      var descriptors = action.type.logoDescriptors || [];
      for (var d = 0; d < descriptors.length; d++) {
        var desc = descriptors[d];
        produced[desc.logoId] += desc.perSheet * action.sheets;
      }
    }
    Object.keys(demanded).forEach(function (logoId) {
      surplus += Math.max(0, (produced[logoId] || 0) - demanded[logoId]);
    });

    return {
      produced: produced,
      demanded: demanded,
      surplus: surplus,
      totalDemand: totalDemand
    };
  }

  function buildCombinationFromActions(actions) {
    var combination = {};
    for (var i = 0; i < actions.length; i++) {
      var action = actions[i];
      var t = action.type;
      if (!combination[t.formatName]) {
        combination[t.formatName] = {
          sheets: 0,
          blueprint: t.blueprint,
          allocations: [],
          _allocMap: {}
        };
      }
      var line = combination[t.formatName];
      line.sheets += action.sheets;
      if (t.logoDescriptors.length === 1) {
        var single = t.logoDescriptors[0];
        var singleKey = "single:" + single.logoId + ":" + single.perSheet;
        if (!line._allocMap[singleKey]) {
          line._allocMap[singleKey] = {
            logoId: single.logoId,
            logoName: single.logoName,
            sheets: 0,
            produced: 0,
            requested: 0,
            perSheet: single.perSheet,
            blueprint: t.blueprint
          };
        }
        line._allocMap[singleKey].sheets += action.sheets;
        line._allocMap[singleKey].produced += single.perSheet * action.sheets;
        line._allocMap[singleKey].requested += single.perSheet * action.sheets;
      } else {
        var sortedMixed = t.logoDescriptors
          .slice()
          .sort(function (a, b) { return String(a.logoId).localeCompare(String(b.logoId)); });
        var mixedKey = "mixed:" + sortedMixed.map(function (d) { return d.logoId + ":" + d.perSheet; }).join("|");
        if (!line._allocMap[mixedKey]) {
          line._allocMap[mixedKey] = {
            logoId: "mixed:" + sortedMixed.map(function (d) { return d.logoId; }).join("|"),
            logoName: sortedMixed.map(function (d) { return d.logoName; }).join(" + "),
            sheets: 0,
            produced: 0,
            requested: 0,
            perSheet: t.totalOnSheet,
            logos: sortedMixed.map(function (d) {
              return {
                logoId: d.logoId,
                logoName: d.logoName,
                perSheet: d.perSheet,
                width: d.width,
                height: d.height,
                produced: 0
              };
            }),
            blueprint: t.blueprint
          };
        }
        line._allocMap[mixedKey].sheets += action.sheets;
        line._allocMap[mixedKey].produced += t.totalOnSheet * action.sheets;
        line._allocMap[mixedKey].requested += t.totalOnSheet * action.sheets;
        for (var md = 0; md < line._allocMap[mixedKey].logos.length; md++) {
          line._allocMap[mixedKey].logos[md].produced += line._allocMap[mixedKey].logos[md].perSheet * action.sheets;
        }
      }
    }
    Object.keys(combination).forEach(function (formatName) {
      var line = combination[formatName];
      line.allocations = Object.keys(line._allocMap)
        .map(function (key) { return line._allocMap[key]; })
        .sort(function (a, b) { return (b.sheets || 0) - (a.sheets || 0); });
      delete line._allocMap;
    });
    return combination;
  }

  function priceCombination(formatSheets, pricingFn) {
    var total = 0;
    Object.keys(formatSheets).forEach(function (formatName) {
      total += Number(pricingFn(formatName, formatSheets[formatName]) || 0);
    });
    return roundMoney(total);
  }

  function buildOrientationOptions(logo, allowRotate) {
    var options = [{ width: logo.width, height: logo.height }];
    if (allowRotate && logo.width !== logo.height) {
      options.push({ width: logo.height, height: logo.width });
    }
    return options;
  }

  function createRowsPlacements(logo, cellW, cellH, cols, rows, startY, spacingCm) {
    var placements = [];
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        placements.push({
          id: logo.id,
          name: logo.name,
          color: logo.color,
          x: c * (cellW + spacingCm),
          y: startY + r * (cellH + spacingCm),
          width: cellW,
          height: cellH
        });
      }
    }
    return placements;
  }

  function createGridPlacementsAt(logo, cellW, cellH, cols, rows, startX, startY, spacingCm) {
    var placements = [];
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        placements.push({
          id: logo.id,
          name: logo.name,
          color: logo.color,
          x: startX + c * (cellW + spacingCm),
          y: startY + r * (cellH + spacingCm),
          width: cellW,
          height: cellH
        });
      }
    }
    return placements;
  }

  function canStackRows(planRows, spacingCm, formatHeight) {
    var totalRows = 0;
    var used = 0;
    for (var i = 0; i < planRows.length; i++) {
      totalRows += planRows[i].rows;
      used += planRows[i].rows * planRows[i].cellH;
    }
    used += Math.max(0, totalRows - 1) * spacingCm;
    return used <= formatHeight + 1e-9;
  }

  function buildMixedSheetTypes(logos, formats, spacingCm, allowRotate) {
    var types = [];
    var seen = {};
    var typeSeq = 0;

    function pushType(type) {
      var key = [
        type.formatName,
        type.logoDescriptors
          .map(function (d) { return d.logoId + ":" + d.perSheet; })
          .sort()
          .join("|")
      ].join("::");
      if (seen[key]) return;
      seen[key] = true;
      types.push(type);
    }

    for (var f = 0; f < formats.length; f++) {
      var format = formats[f];

      for (var i = 0; i < logos.length; i++) {
        var singleLogo = logos[i];
        var singleBlueprint = buildSingleLogoBlueprint(singleLogo, format, spacingCm, allowRotate);
        if (!singleBlueprint || singleBlueprint.totalOnSheet <= 0) continue;
        pushType({
          id: "T" + typeSeq++,
          formatName: format.name,
          format: format,
          blueprint: singleBlueprint,
          totalOnSheet: singleBlueprint.totalOnSheet,
          logoDescriptors: [{
            logoId: singleLogo.id,
            logoName: singleLogo.name,
            perSheet: singleBlueprint.totalOnSheet,
            width: singleLogo.width,
            height: singleLogo.height
          }]
        });
      }

      for (var a = 0; a < logos.length; a++) {
        for (var b = a + 1; b < logos.length; b++) {
          var logoA = logos[a];
          var logoB = logos[b];
          var orientA = buildOrientationOptions(logoA, allowRotate);
          var orientB = buildOrientationOptions(logoB, allowRotate);

          for (var oa = 0; oa < orientA.length; oa++) {
            for (var ob = 0; ob < orientB.length; ob++) {
              var cellAW = orientA[oa].width;
              var cellAH = orientA[oa].height;
              var cellBW = orientB[ob].width;
              var cellBH = orientB[ob].height;
              var colsA = Math.floor((format.width + spacingCm) / (cellAW + spacingCm));
              var colsB = Math.floor((format.width + spacingCm) / (cellBW + spacingCm));
              if (colsA <= 0 || colsB <= 0) continue;

              var maxRowsA = Math.floor((format.height + spacingCm) / (cellAH + spacingCm));
              var maxRowsB = Math.floor((format.height + spacingCm) / (cellBH + spacingCm));
              var needRowsA = Math.max(1, Math.ceil(logoA.quantity / colsA));
              var needRowsB = Math.max(1, Math.ceil(logoB.quantity / colsB));
              maxRowsA = Math.min(maxRowsA, needRowsA + 2);
              maxRowsB = Math.min(maxRowsB, needRowsB + 2);

              for (var rowsA = 1; rowsA <= maxRowsA; rowsA++) {
                for (var rowsB = 1; rowsB <= maxRowsB; rowsB++) {
                  var stack = [
                    { rows: rowsA, cellH: cellAH },
                    { rows: rowsB, cellH: cellBH }
                  ];
                  if (!canStackRows(stack, spacingCm, format.height)) continue;

                  var yA = 0;
                  var yB = rowsA * cellAH + rowsA * spacingCm;
                  var placeA = createRowsPlacements(logoA, cellAW, cellAH, colsA, rowsA, yA, spacingCm);
                  var placeB = createRowsPlacements(logoB, cellBW, cellBH, colsB, rowsB, yB, spacingCm);
                  var perA = colsA * rowsA;
                  var perB = colsB * rowsB;
                  if (perA <= 0 || perB <= 0) continue;

                  pushType({
                    id: "T" + typeSeq++,
                    formatName: format.name,
                    format: format,
                    totalOnSheet: perA + perB,
                    blueprint: {
                      format: format,
                      placements: placeA.concat(placeB),
                      perSheet: (function () {
                        var out = {};
                        out[logoA.id] = perA;
                        out[logoB.id] = perB;
                        return out;
                      })(),
                      totalOnSheet: perA + perB
                    },
                    logoDescriptors: [
                      { logoId: logoA.id, logoName: logoA.name, perSheet: perA, width: logoA.width, height: logoA.height },
                      { logoId: logoB.id, logoName: logoB.name, perSheet: perB, width: logoB.width, height: logoB.height }
                    ]
                  });
                }
              }

              var maxColsA = Math.floor((format.width + spacingCm) / (cellAW + spacingCm));
              var maxColsB = Math.floor((format.width + spacingCm) / (cellBW + spacingCm));
              var maxRowsColA = Math.floor((format.height + spacingCm) / (cellAH + spacingCm));
              var maxRowsColB = Math.floor((format.height + spacingCm) / (cellBH + spacingCm));
              var colCapA = Math.min(maxColsA, 4);
              var colCapB = Math.min(maxColsB, 4);
              var rowCapA = Math.min(maxRowsColA, 4);
              var rowCapB = Math.min(maxRowsColB, 4);

              for (var colsPartA = 1; colsPartA <= colCapA; colsPartA++) {
                for (var colsPartB = 1; colsPartB <= colCapB; colsPartB++) {
                  var partAWidth = colsPartA * cellAW + Math.max(0, colsPartA - 1) * spacingCm;
                  var partBWidth = colsPartB * cellBW + Math.max(0, colsPartB - 1) * spacingCm;
                  var totalWidth = partAWidth + spacingCm + partBWidth;
                  if (totalWidth > format.width + 1e-9) continue;

                  for (var rowsPartA = 1; rowsPartA <= rowCapA; rowsPartA++) {
                    for (var rowsPartB = 1; rowsPartB <= rowCapB; rowsPartB++) {
                      var partAHeight = rowsPartA * cellAH + Math.max(0, rowsPartA - 1) * spacingCm;
                      var partBHeight = rowsPartB * cellBH + Math.max(0, rowsPartB - 1) * spacingCm;
                      if (partAHeight > format.height + 1e-9 || partBHeight > format.height + 1e-9) continue;

                      var perPartA = colsPartA * rowsPartA;
                      var perPartB = colsPartB * rowsPartB;
                      if (perPartA <= 0 || perPartB <= 0) continue;

                      var pxA = createGridPlacementsAt(logoA, cellAW, cellAH, colsPartA, rowsPartA, 0, 0, spacingCm);
                      var startXB = partAWidth + spacingCm;
                      var pxB = createGridPlacementsAt(logoB, cellBW, cellBH, colsPartB, rowsPartB, startXB, 0, spacingCm);

                      pushType({
                        id: "T" + typeSeq++,
                        formatName: format.name,
                        format: format,
                        totalOnSheet: perPartA + perPartB,
                        blueprint: {
                          format: format,
                          placements: pxA.concat(pxB),
                          perSheet: (function () {
                            var out = {};
                            out[logoA.id] = perPartA;
                            out[logoB.id] = perPartB;
                            return out;
                          })(),
                          totalOnSheet: perPartA + perPartB
                        },
                        logoDescriptors: [
                          { logoId: logoA.id, logoName: logoA.name, perSheet: perPartA, width: logoA.width, height: logoA.height },
                          { logoId: logoB.id, logoName: logoB.name, perSheet: perPartB, width: logoB.width, height: logoB.height }
                        ]
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    if (logos.length >= 3 && logos.length <= 8) {
      var ROW_CAP = 6;
      var COL_CAP = 6;
      for (var fAll = 0; fAll < formats.length; fAll++) {
        var fmtAll = formats[fAll];
        (function enumerateAllLogoStacked() {
          var n = logos.length;
          var orientDims = [];
          function orientProduct(idx) {
            if (idx >= n) {
              var colsArr = [];
              var gi;
              for (gi = 0; gi < n; gi++) {
                colsArr[gi] = Math.floor(
                  (fmtAll.width + spacingCm) / (orientDims[gi].w + spacingCm)
                );
                if (colsArr[gi] <= 0) return;
              }
              var maxRowsFmt = [];
              for (gi = 0; gi < n; gi++) {
                maxRowsFmt[gi] = Math.floor(
                  (fmtAll.height + spacingCm) / (orientDims[gi].h + spacingCm)
                );
              }
              function dfsRows(logoIdx, rowChoices) {
                if (logoIdx >= n) {
                  var stackSpec = [];
                  for (var si = 0; si < n; si++) {
                    stackSpec.push({ rows: rowChoices[si], cellH: orientDims[si].h });
                  }
                  if (!canStackRows(stackSpec, spacingCm, fmtAll.height)) return;
                  var placementsAll = [];
                  var perSheetObj = {};
                  var yCur = 0;
                  for (var li = 0; li < n; li++) {
                    var od = orientDims[li];
                    var colsL = colsArr[li];
                    var rowsL = rowChoices[li];
                    var perL = colsL * rowsL;
                    if (perL <= 0) return;
                    placementsAll = placementsAll.concat(
                      createRowsPlacements(
                        logos[li],
                        od.w,
                        od.h,
                        colsL,
                        rowsL,
                        yCur,
                        spacingCm
                      )
                    );
                    perSheetObj[logos[li].id] = perL;
                    yCur += rowsL * od.h + rowsL * spacingCm;
                  }
                  pushType({
                    id: "T" + typeSeq++,
                    formatName: fmtAll.name,
                    format: fmtAll,
                    totalOnSheet: placementsAll.length,
                    blueprint: {
                      format: fmtAll,
                      placements: placementsAll,
                      perSheet: perSheetObj,
                      totalOnSheet: placementsAll.length
                    },
                    logoDescriptors: logos.map(function (lg) {
                      return {
                        logoId: lg.id,
                        logoName: lg.name,
                        perSheet: perSheetObj[lg.id],
                        width: lg.width,
                        height: lg.height
                      };
                    })
                  });
                  return;
                }
                var od = orientDims[logoIdx];
                var colsL = colsArr[logoIdx];
                var maxRows = maxRowsFmt[logoIdx];
                var needRows = Math.max(1, Math.ceil(logos[logoIdx].quantity / colsL));
                var hi = Math.min(maxRows, needRows + 2, ROW_CAP);
                for (var rr = 1; rr <= hi; rr++) {
                  rowChoices[logoIdx] = rr;
                  dfsRows(logoIdx + 1, rowChoices);
                }
              }
              dfsRows(0, []);
              return;
            }
            var opts = buildOrientationOptions(logos[idx], allowRotate);
            for (var oi = 0; oi < opts.length; oi++) {
              orientDims[idx] = { w: opts[oi].width, h: opts[oi].height };
              orientProduct(idx + 1);
            }
          }
          orientProduct(0);
        })();
        (function enumerateAllLogoColumns() {
          var n = logos.length;
          var orientDims = [];
          function orientProduct(idx) {
            if (idx >= n) {
              var maxColsFmt = [];
              var maxRowsFmt = [];
              for (var gi = 0; gi < n; gi++) {
                maxColsFmt[gi] = Math.floor(
                  (fmtAll.width + spacingCm) / (orientDims[gi].w + spacingCm)
                );
                maxRowsFmt[gi] = Math.floor(
                  (fmtAll.height + spacingCm) / (orientDims[gi].h + spacingCm)
                );
                if (maxColsFmt[gi] <= 0 || maxRowsFmt[gi] <= 0) return;
              }
              function emitBlockChoices(blockChoices) {
                var maxMask = Math.pow(2, n);
                for (var mask = 0; mask < maxMask; mask++) {
                  var shelfMeta = [
                    { width: 0, height: 0, count: 0 },
                    { width: 0, height: 0, count: 0 }
                  ];
                  for (var bi = 0; bi < n; bi++) {
                    var block = blockChoices[bi];
                    var shelfIdx = (mask >> bi) & 1;
                    var shelf = shelfMeta[shelfIdx];
                    shelf.width += (shelf.count > 0 ? spacingCm : 0) + block.width;
                    shelf.height = Math.max(shelf.height, block.height);
                    shelf.count += 1;
                  }
                  if (shelfMeta[0].width > fmtAll.width + 1e-9 || shelfMeta[1].width > fmtAll.width + 1e-9) continue;
                  var usedHeight = 0;
                  if (shelfMeta[0].count > 0) usedHeight += shelfMeta[0].height;
                  if (shelfMeta[1].count > 0) {
                    if (usedHeight > 0) usedHeight += spacingCm;
                    usedHeight += shelfMeta[1].height;
                  }
                  if (usedHeight > fmtAll.height + 1e-9) continue;

                  var placementsAll = [];
                  var perSheetObj = {};
                  var xByShelf = [0, 0];
                  var yByShelf = [0, shelfMeta[0].count > 0 ? shelfMeta[0].height + spacingCm : 0];
                  for (var pi = 0; pi < n; pi++) {
                    var pBlock = blockChoices[pi];
                    var od = orientDims[pi];
                    var shelfId = (mask >> pi) & 1;
                    var per = pBlock.cols * pBlock.rows;
                    if (per <= 0) return;
                    placementsAll = placementsAll.concat(
                      createGridPlacementsAt(
                        logos[pi],
                        od.w,
                        od.h,
                        pBlock.cols,
                        pBlock.rows,
                        xByShelf[shelfId],
                        yByShelf[shelfId],
                        spacingCm
                      )
                    );
                    perSheetObj[logos[pi].id] = per;
                    xByShelf[shelfId] += pBlock.width + spacingCm;
                  }

                  pushType({
                    id: "T" + typeSeq++,
                    formatName: fmtAll.name,
                    format: fmtAll,
                    totalOnSheet: placementsAll.length,
                    blueprint: {
                      format: fmtAll,
                      placements: placementsAll,
                      perSheet: perSheetObj,
                      totalOnSheet: placementsAll.length
                    },
                    logoDescriptors: logos.map(function (lg) {
                      return {
                        logoId: lg.id,
                        logoName: lg.name,
                        perSheet: perSheetObj[lg.id],
                        width: lg.width,
                        height: lg.height
                      };
                    })
                  });
                }
              }

              function dfsBlocks(logoIdx, blockChoices, usedWidth) {
                if (logoIdx >= n) {
                  emitBlockChoices(blockChoices);
                  return;
                }
                var od = orientDims[logoIdx];
                var colsHi = Math.min(maxColsFmt[logoIdx], COL_CAP);
                for (var cols = 1; cols <= colsHi; cols++) {
                  var rowsNeed = Math.max(1, Math.ceil(logos[logoIdx].quantity / cols));
                  var rowsHi = Math.min(maxRowsFmt[logoIdx], rowsNeed + 2, ROW_CAP);
                  for (var rows = 1; rows <= rowsHi; rows++) {
                    var blockW = cols * od.w + Math.max(0, cols - 1) * spacingCm;
                    var blockH = rows * od.h + Math.max(0, rows - 1) * spacingCm;
                    if (blockW > fmtAll.width + 1e-9 || blockH > fmtAll.height + 1e-9) continue;
                    var nextWidth = usedWidth + (logoIdx > 0 ? spacingCm : 0) + blockW;
                    if (nextWidth > fmtAll.width * 2 + spacingCm + 1e-9) continue;
                    blockChoices[logoIdx] = {
                      cols: cols,
                      rows: rows,
                      width: blockW,
                      height: blockH
                    };
                    dfsBlocks(logoIdx + 1, blockChoices, nextWidth);
                  }
                }
              }
              dfsBlocks(0, [], 0);
              return;
            }
            var opts = buildOrientationOptions(logos[idx], allowRotate);
            for (var oi = 0; oi < opts.length; oi++) {
              orientDims[idx] = { w: opts[oi].width, h: opts[oi].height };
              orientProduct(idx + 1);
            }
          }
          orientProduct(0);
        })();
      }
    }

    return types;
  }

  function buildDedicatedRanked(logos, formats, spacingCm, allowRotate, pricingFn, extraCostFn, maxSheetsPerPair) {
    var optionsByLogo = {};
    for (var i = 0; i < logos.length; i++) {
      var logo = logos[i];
      optionsByLogo[logo.id] = [];
      for (var j = 0; j < formats.length; j++) {
        var format = formats[j];
        var blueprint = buildSingleLogoBlueprint(logo, format, spacingCm, allowRotate);
        if (!blueprint || blueprint.totalOnSheet <= 0) continue;
        var sheetsNeeded = Math.ceil(logo.quantity / blueprint.totalOnSheet);
        if (sheetsNeeded > maxSheetsPerPair) continue;
        optionsByLogo[logo.id].push({
          id: "DED:" + logo.id + ":" + format.name + ":" + blueprint.totalOnSheet,
          formatName: format.name,
          format: format,
          totalOnSheet: blueprint.totalOnSheet,
          blueprint: blueprint,
          logoDescriptors: [{
            logoId: logo.id,
            logoName: logo.name,
            perSheet: blueprint.totalOnSheet,
            width: logo.width,
            height: logo.height
          }]
        });
      }
      if (!optionsByLogo[logo.id].length) return [];
    }

    var ranked = [];
    var current = [];
    var logoOrder = logos.map(function (l) { return l.id; });

    function dfs(idx) {
      if (idx >= logoOrder.length) {
        var actions = current.map(function (entry) {
          var perSheet = entry.type.logoDescriptors[0].perSheet;
          return {
            type: entry.type,
            sheets: Math.ceil(entry.logo.quantity / perSheet)
          };
        });
        var combo = buildCombinationFromActions(actions);
        var coverage = aggregateCoverage(logos, actions);
        var formatSheets = {};
        Object.keys(combo).forEach(function (name) { formatSheets[name] = combo[name].sheets; });
        var baseCost = priceCombination(formatSheets, pricingFn);
        var extraCost = Number(extraCostFn({ logos: logos, combination: combo, coverage: coverage }) || 0);
        var totalCost = roundMoney(baseCost + extraCost);
        var totalSheets = Object.keys(combo).reduce(function (acc, formatName) {
          return acc + combo[formatName].sheets;
        }, 0);
        ranked.push({
          combination: combo,
          totalSheets: totalSheets,
          totalCost: totalCost,
          surplus: coverage.surplus,
          coverage: coverage,
          pricePerLogo: coverage.totalDemand > 0 ? roundMoney(totalCost / coverage.totalDemand) : 0
        });
        return;
      }
      var logoId = logoOrder[idx];
      var logo = logos.find(function (x) { return x.id === logoId; });
      var options = optionsByLogo[logoId] || [];
      for (var k = 0; k < options.length; k++) {
        current.push({ logo: logo, type: options[k] });
        dfs(idx + 1);
        current.pop();
      }
    }

    dfs(0);
    return ranked;
  }

  function optimize(params) {
    var logos = (params.logos || []).map(normalizeLogo).filter(function (logo) {
      return logo.quantity > 0 && logo.width > 0 && logo.height > 0;
    });
    var formats = params.formats || [];
    var spacingCm = Math.max(0, Number(params.spacingCm || 0));
    var allowRotate = params.allowRotate !== false;
    var pricingFn = params.pricingFn;
    var maxSheetsPerPair = Math.max(1, Number(params.maxSheetsPerFormat || 250));
    var extraCostFn = typeof params.extraCostFn === "function" ? params.extraCostFn : function () { return 0; };

    if (!logos.length || !formats.length || typeof pricingFn !== "function") {
      return { ranked: [], blueprints: {} };
    }

    var sheetTypes = buildMixedSheetTypes(logos, formats, spacingCm, allowRotate);
    if (!sheetTypes.length) return { ranked: [], blueprints: {} };

    var logoOrder = logos.map(function (l) { return l.id; });
    var demandByLogo = {};
    var formatNames = {};
    for (var i = 0; i < logos.length; i++) demandByLogo[logos[i].id] = logos[i].quantity;
    for (var t = 0; t < sheetTypes.length; t++) formatNames[sheetTypes[t].formatName] = true;

    var relevantByLogo = {};
    for (var li = 0; li < logoOrder.length; li++) relevantByLogo[logoOrder[li]] = [];
    for (var ti = 0; ti < sheetTypes.length; ti++) {
      var descs = sheetTypes[ti].logoDescriptors;
      for (var di = 0; di < descs.length; di++) {
        relevantByLogo[descs[di].logoId].push(sheetTypes[ti]);
      }
    }
    for (var lz = 0; lz < logoOrder.length; lz++) {
      if (!relevantByLogo[logoOrder[lz]].length) return { ranked: [], blueprints: {} };
    }

    var ranked = [];
    var current = [];
    var bestCost = Infinity;
    var memo = {};
    var startMs = Date.now();
    var nodeCount = 0;
    var aborted = false;
    var maxNodes = logos.length <= 2 ? 180000 : logos.length === 3 ? 120000 : 70000;
    var maxMs = logos.length <= 2 ? 5000 : 2500;

    function allCovered(remaining) {
      for (var i = 0; i < logoOrder.length; i++) {
        if ((remaining[logoOrder[i]] || 0) > 0) return false;
      }
      return true;
    }

    function pickTargetLogo(remaining) {
      var bestLogoId = logoOrder[0];
      var bestRem = -1;
      for (var i = 0; i < logoOrder.length; i++) {
        var id = logoOrder[i];
        if ((remaining[id] || 0) > bestRem) {
          bestRem = remaining[id] || 0;
          bestLogoId = id;
        }
      }
      return bestLogoId;
    }

    function stateKey(remaining, formatSheets) {
      var rem = logoOrder.map(function (id) { return remaining[id] || 0; }).join(",");
      var fmt = Object.keys(formatNames)
        .sort()
        .map(function (name) { return name + ":" + (formatSheets[name] || 0); })
        .join(",");
      return rem + "||" + fmt;
    }

    function dfs(remaining, formatSheets) {
      nodeCount += 1;
      if (nodeCount > maxNodes || Date.now() - startMs > maxMs) {
        aborted = true;
        return;
      }
      var runningBaseCost = priceCombination(formatSheets, pricingFn);

      var key = stateKey(remaining, formatSheets);
      if (memo[key] != null && memo[key] <= runningBaseCost) return;
      memo[key] = runningBaseCost;

      if (allCovered(remaining)) {
        var combo = buildCombinationFromActions(current);
        var coverage = aggregateCoverage(logos, current);
        var baseCost = priceCombination(formatSheets, pricingFn);
        var extraCost = Number(extraCostFn({ logos: logos, combination: combo, coverage: coverage }) || 0);
        var totalCost = roundMoney(baseCost + extraCost);
        var totalSheets = Object.keys(combo).reduce(function (acc, formatName) {
          return acc + combo[formatName].sheets;
        }, 0);
        if (totalCost < bestCost) bestCost = totalCost;

        ranked.push({
          combination: combo,
          totalSheets: totalSheets,
          totalCost: totalCost,
          surplus: coverage.surplus,
          coverage: coverage,
          pricePerLogo: coverage.totalDemand > 0 ? roundMoney(totalCost / coverage.totalDemand) : 0
        });
        return;
      }

      var targetLogoId = pickTargetLogo(remaining);
      var allCandidates = (relevantByLogo[targetLogoId] || []).slice().sort(function (a, b) {
        if (a.logoDescriptors.length !== b.logoDescriptors.length) {
          return b.logoDescriptors.length - a.logoDescriptors.length;
        }
        return (b.totalOnSheet || 0) - (a.totalOnSheet || 0);
      });
      var candidates = allCandidates.filter(function (type) {
        for (var i = 0; i < type.logoDescriptors.length; i++) {
          var desc = type.logoDescriptors[i];
          if (desc.logoId !== targetLogoId && (remaining[desc.logoId] || 0) <= 0) {
            return false;
          }
        }
        return true;
      });
      if (!candidates.length) candidates = allCandidates;

      for (var c = 0; c < candidates.length; c++) {
        var type = candidates[c];
        var targetPerSheet = 0;
        var maxRepeatByAll = maxSheetsPerPair;
        for (var td = 0; td < type.logoDescriptors.length; td++) {
          var dsc = type.logoDescriptors[td];
          if (dsc.logoId === targetLogoId) targetPerSheet = dsc.perSheet;
          var rem = Number(remaining[dsc.logoId] || 0);
          if (rem <= 0) {
            maxRepeatByAll = 0;
            break;
          }
          var localMax = Math.ceil(rem / dsc.perSheet) + 1;
          if (localMax < maxRepeatByAll) maxRepeatByAll = localMax;
        }
        if (targetPerSheet <= 0) continue;
        if (maxRepeatByAll <= 0) continue;

        var maxRepeat = Math.ceil((remaining[targetLogoId] || 0) / targetPerSheet) + 1;
        maxRepeat = Math.min(maxRepeat, maxSheetsPerPair, maxRepeatByAll);
        for (var n = 1; n <= maxRepeat; n++) {
          var nextFormatSheets = {};
          Object.keys(formatSheets).forEach(function (name) {
            nextFormatSheets[name] = formatSheets[name];
          });
          nextFormatSheets[type.formatName] = (nextFormatSheets[type.formatName] || 0) + n;
          if (nextFormatSheets[type.formatName] > maxSheetsPerPair) continue;

          var nextRemaining = {};
          for (var i = 0; i < logoOrder.length; i++) {
            nextRemaining[logoOrder[i]] = remaining[logoOrder[i]];
          }
          for (var d = 0; d < type.logoDescriptors.length; d++) {
            var desc = type.logoDescriptors[d];
            nextRemaining[desc.logoId] = Math.max(0, (nextRemaining[desc.logoId] || 0) - desc.perSheet * n);
          }

          current.push({ type: type, sheets: n });
          dfs(nextRemaining, nextFormatSheets);
          current.pop();
        }
      }
    }

    var initialRemaining = {};
    var initialFormatSheets = {};
    for (var l = 0; l < logoOrder.length; l++) initialRemaining[logoOrder[l]] = demandByLogo[logoOrder[l]];
    Object.keys(formatNames).forEach(function (name) { initialFormatSheets[name] = 0; });
    dfs(initialRemaining, initialFormatSheets);

    if (!ranked.length) {
      ranked = buildDedicatedRanked(logos, formats, spacingCm, allowRotate, pricingFn, extraCostFn, maxSheetsPerPair);
    }

    for (var st = 0; st < sheetTypes.length; st++) {
      var type = sheetTypes[st];
      var coversAll = true;
      for (var lo = 0; lo < logoOrder.length; lo++) {
        var logoId = logoOrder[lo];
        var has = type.logoDescriptors.some(function (d) { return d.logoId === logoId && d.perSheet > 0; });
        if (!has) {
          coversAll = false;
          break;
        }
      }
      if (!coversAll) continue;

      var neededSheets = 0;
      for (var ld = 0; ld < type.logoDescriptors.length; ld++) {
        var desc = type.logoDescriptors[ld];
        neededSheets = Math.max(neededSheets, Math.ceil((demandByLogo[desc.logoId] || 0) / desc.perSheet));
      }
      if (neededSheets <= 0 || neededSheets > maxSheetsPerPair) continue;

      var oneAction = [{ type: type, sheets: neededSheets }];
      var oneCombo = buildCombinationFromActions(oneAction);
      var oneCoverage = aggregateCoverage(logos, oneAction);
      var oneFormatSheets = {};
      oneFormatSheets[type.formatName] = neededSheets;
      var oneBaseCost = priceCombination(oneFormatSheets, pricingFn);
      var oneExtraCost = Number(extraCostFn({ logos: logos, combination: oneCombo, coverage: oneCoverage }) || 0);
      var oneTotalCost = roundMoney(oneBaseCost + oneExtraCost);
      ranked.push({
        combination: oneCombo,
        totalSheets: neededSheets,
        totalCost: oneTotalCost,
        surplus: oneCoverage.surplus,
        coverage: oneCoverage,
        pricePerLogo: oneCoverage.totalDemand > 0 ? roundMoney(oneTotalCost / oneCoverage.totalDemand) : 0
      });
    }

    ranked.sort(function (a, b) {
      if (a.totalCost !== b.totalCost) return a.totalCost - b.totalCost;
      if (a.surplus !== b.surplus) return a.surplus - b.surplus;
      return a.totalSheets - b.totalSheets;
    });

    var unique = [];
    var seen = {};
    for (var r = 0; r < ranked.length; r++) {
      var key = JSON.stringify(
        Object.keys(ranked[r].combination)
          .sort()
          .map(function (name) {
            return [
              name,
              ranked[r].combination[name].sheets,
              ranked[r].combination[name].allocations
                .map(function (a) { return a.logoId + ":" + a.sheets; })
                .sort()
            ];
          })
      );
      if (!seen[key]) {
        seen[key] = true;
        unique.push(ranked[r]);
      }
    }

    return {
      ranked: unique,
      blueprints: {}
    };
  }

  global.CalculatorEngine = {
    FORMAT_DIMENSIONS: FORMAT_DIMENSIONS,
    normalizeLogo: normalizeLogo,
    optimize: optimize
  };
})(window);
